import { createSlice, nanoid } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { TASK_STATE_VALIDATION } from 'src/constants';
import { auth } from 'src/contexts/FirebaseContext';
import { taskDefaultModel } from 'src/helpers/task';
import { changeOnObject } from 'src/utils/changeOnObject';
import firestore from 'src/utils/firestore';
import { serverTime } from 'src/utils/serverTime';
import { taskCreationNotification, taskUpdateNotification } from './notifications';

const initialState = {
  tasks: []
};

const slice = createSlice({
  name: 'task_without_project',
  initialState,
  reducers: {
    addTask(state, action) {
      state.tasks.shift(action.payload);
    },
    addTasks(state, action) {
      state.tasks = action.payload;
    },
    updateTasks(state, action) {
      const task = action.payload;

      const position = state.tasks.findIndex((_one) => _one.id === task?.id);
      if (position !== -1) {
        state.tasks[position] = { ...state.tasks[position], ...task };
      }
    }
  }
});

export default slice.reducer;

export const { addTasks } = slice.actions;

export function createTaskWithoutProject(values, callback) {
  return async (dispatch, getState) => {
    const {
      kanban: { currentProject }
    } = getState();
    let id = values?.id || nanoid(26);
    const { uid, displayName, email } = auth.currentUser;

    let task = {
      id,
      ...taskDefaultModel,
      ...values,
      createdBy: { id: uid, email, name: displayName },
      projectState: currentProject?.state || 'open'
    };

    let observerIds = task.observers.map((pers) => pers.id);
    let canAccessId = task.assignee.map((pers) => pers.id);

    canAccessId.push(task.createdBy.id);
    canAccessId.concat(observerIds);

    const assigneIds = task?.assignee ? task?.assignee?.map((_one) => _one.id) : [];
    let assigneByIds = task?.assigneByIds || [];

    if (task.assignee?.length || task?.responsable !== null) {
      assigneByIds = uniq([uid, ...assigneByIds]);
    }

    task = {
      ...task,
      name: task?.name?.replace(/<[^>]+>/g, ''),
      state: TASK_STATE_VALIDATION.PENDING,
      isDeleted: false,
      canAccessId,
      assigneIds,
      assigneByIds,
      isDefaultTask: true,
      deadLine: task?.due?.at(1),
      createdAt: serverTime(),
      updatedAt: serverTime(),
      subTasksCount: 0
    };

    try {
      dispatch(slice.actions.addTask(task));
      await firestore
        .collection('tasks')
        .doc(id)
        .set({ ...task }, { merge: true });
      if (callback) {
        callback(id);
      }
      dispatch(taskCreationNotification({ task }));
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateTaskWithoutProject(oldTask, values, callback) {
  return async (dispatch, getState) => {
    let temp = { ...values };
    const { id } = oldTask;

    const {
      kanban: { currentProject, sProject }
    } = getState();

    let project = currentProject || sProject;

    try {
      if (id) {
        dispatch(slice.actions.updateTasks({ id, values }));
        if (temp?.due) {
          temp = { ...temp, deadLine: temp?.due?.at(1) };
        }
        if (temp?.assignee) {
        }
        await firestore.collection('tasks').doc(id).set(temp, { merge: true });
        const change = changeOnObject(oldTask, values);
        dispatch(
          taskUpdateNotification({
            card: { ...oldTask, ...values },
            change,
            projectName: project?.name,
            theOld: oldTask
          })
        );
        if (callback) callback();
      }
    } catch (error) {
      console.log(error);
    }
  };
}
